import { render, staticRenderFns } from "./A3ClosedBoardCollectionPage.vue?vue&type=template&id=f29d1e48&"
import script from "./A3ClosedBoardCollectionPage.vue?vue&type=script&lang=ts&"
export * from "./A3ClosedBoardCollectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f29d1e48')) {
      api.createRecord('f29d1e48', component.options)
    } else {
      api.reload('f29d1e48', component.options)
    }
    module.hot.accept("./A3ClosedBoardCollectionPage.vue?vue&type=template&id=f29d1e48&", function () {
      api.rerender('f29d1e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/A3/A3ClosedBoardCollectionPage.vue"
export default component.exports